import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const ModalRechazarLicencia = (props) => {
  const fechaFormat = new Date().toISOString().split("T")[0];
  const [fecha, setFecha] = useState("");
  const [motivo, setMotivo] = useState("");
  const [disabled, setDisabled] = useState("");
  const [revisado, setRevisado] = useState();
  const actualizar = () => {
    props.onHideAcepta();
  };
  const enviarMotivo = (e) => {
    props.setMotivo(e);
  };
  const cerrar = () => {
    props.onHide();
  };
  return (
    <Modal
      show={props.show}
      aria-labelledby="contained-modal-title-vcenter"
      size="xl"
      contentClassName="p-0 m-0"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.consulta) {
          setDisabled(true);
          setRevisado(props.revisado);
          setMotivo(props.motivo);
          setFecha(new Date(props.fecha).toISOString().split("T")[0]);
        } else {
          setDisabled(false);
          setRevisado("");
          setMotivo("");
          setFecha(fechaFormat);
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold text-light m-0">Motivo del Rechazo</h3>
        <button className="btn btn-sm bg-light" onClick={() => cerrar()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-between row">
        <div className="col-md-12 row mx-auto align-items-start">
          <div className="col-md-9 mr-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Motivo del Rechazo
              </span>
              <textarea
                disabled={disabled}
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="fecha"
                style={{
                  minHeight: "27px",
                }}
                value={motivo}
                onChange={(e) => {
                  enviarMotivo(e.target.value);
                  setMotivo(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="col-md-3 ml-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Fecha:
              </span>
              <input
                type="date"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="fecha"
                defaultValue={fecha}
                disabled
              />
            </div>
          </div>
          {disabled && (
            <div className="col-md-9 mr-auto row my-1 py-1">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Revisado Por:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={revisado}
                  disabled
                />
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {!disabled && (
          <button
            type="button"
            style={{ margin: "2px" }}
            className="fw-bold btn btn-primary btn-sm rounded-pill"
            onClick={() => {
              actualizar();
            }}
          >
            <i className="fa fa-check"> Aceptar</i>
          </button>
        )}

        <button
          onClick={() => cerrar()}
          type="button"
          style={{ margin: "2px" }}
          className="fw-bold btn btn-danger btn-sm rounded-pill"
        >
          <i className="fa fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRechazarLicencia;
